<template>
  <el-dialog
    title="请确定本次米单配置的分组结果"
    :visible="visible"
    :before-close="closeDialog"
    width="38%">
    <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
      <h3>任务总数量：{{total}}</h3>
      <h3>创建虚拟任务数量：{{groupedCnt}}</h3>
      <h3>共需预算：{{data.cost}}元</h3>
    </div>
    <h3>可以组合为米单</h3>
    <div class="item" v-for="(item, index) in grouped" :key="`grouped` + index">
      <span>{{item.grp_size}}个任务</span>
      <span>{{item.grp_cnt}}组</span>
    </div>
    <h3>不可组合为米单</h3>
    <div class="item" v-for="(item, index) in ungrouped" :key="`ungrouped` + index">
      <span>{{item.grp_cnt}}个任务</span>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="onConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    visible: Boolean,
    data: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
    }
  },
  computed: {
    grouped () {
      if (!this.data.group) {
        return []
      }
      return this.data.group.filter(item => item.grp_size !== 1)
    },
    ungrouped () {
      if (!this.data.group) {
        return []
      }
      return this.data.group.filter(item => item.grp_size === 1)
    },
    groupedCnt () {
      return this.grouped.reduce((total, current) => {
        return total + current.grp_cnt
      }, 0)
    },
    total () {
      return this.grouped.reduce((total, current) => {
        return total + current.grp_size * current.grp_cnt
      }, 0) + this.ungrouped.reduce((total, current) => {
        return total + current.grp_cnt
      }, 0)
    },
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    onConfirm () {
      this.$emit('confirm')
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
  }
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.item {
  margin-bottom: 6px;
  span {
    font-size: 16px;
  }
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/midan/components/MidanPreviewDialog.vue